import React from "react";
import ForecastRouter from './Forecast/Router';
export { getFields } from './Forecast/Router';

export default function CostForecastRouter(props) {
    return (
        <ForecastRouter {...props} mode='COST' />
    );
};
